export default __webpack_public_path__ + "static/media/web.9d41d560.gif";